var cio_datamodel = require("cio-datamodel");
var colors = require("../colors/colors.js");
var editor_2d = require("editor-2d");
var lib_geometry = require("lib-geometry");

//TODO: reuse symbolterminaldatatosvg from symboleditor
var drawSymbolTerminalDataTo2D = function (svg, group, data, toFill) {
    console.assert(data instanceof cio_datamodel.SymbolTerminalData);
    var x = data.pos().getX();
    var y = data.pos().getY();
    var g = svg.group(group);
    var c_attrs = {
        transform: editor_2d.toSVGutil.rotateTransform(data),
        fill: colors.terminalFill,
        stroke: colors.terminalStroke,
        strokeWidth: 0.8,
        fillOpacity: (toFill)? 1 : 0,
        fillRule: "evenodd"
    };
    svg.circle(g, x, y, 3.5, c_attrs);

    // REMOVED LINE TO MATCH EAGLE
    // var line_attrs = {
    //     strokeWidth: 1.5,
    //     stroke: colors.terminalStroke,
    //     'stroke-linecap': "round"
    // };
    // var lineStart = (new lib_geometry.Coord(x+1.25+1.5, y)).rotate(data.angle(), new lib_geometry.Coord(x, y));
    // var lineEnd = (new lib_geometry.Coord(x+10, y)).rotate(data.angle(), new lib_geometry.Coord(x, y));
    // svg.line(g, lineStart.x, lineStart.y, lineEnd.x, lineEnd.y, line_attrs);
    // lineStart = lineEnd = null; // cleanup

    return g;
};

module.exports = drawSymbolTerminalDataTo2D;
